import { useParams, Navigate } from 'react-router-dom';

/** Auction detail retired - redirect to the equivalent product page. */
export default function AuctionDetail() {
  const { id } = useParams();
  return <Navigate to={id ? `/p/${id}` : '/c/all'} replace />;
}
